import React, { useState } from 'react';

import { Header } from '../components/header/header';
import { RadioButtons } from '../components/radio-buttons/radio-buttons';
import SporreskjemaButton from '../components/sporreskjema-button/sporreskjema-button';
import { StepNavigation } from '../components/step-navigation/step-navigation';
import { SvgCardType } from '../components/svg-card/svg-card-types';
import { useBankregnr } from '../config';
import { useWindowScrollTop } from '../sporsmalsflyt/hooks';
import { toOptions } from '../sporsmalsflyt/radio/radio';
import { RadioAlternativ } from '../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { SideType } from '../utils/piwik-utils';

interface Props {
    title: string;
    onNext: (svarId: string) => void;
    navigateToParent: () => void;
    alternativer: RadioAlternativ[];
    kategoriId: string;
    radioButtonsLabel?: string;
    radioButtonsSubLabel?: string;
    svgCardType?: SvgCardType;
}

export const GruppeLandingsside = ({
    svgCardType,
    title,
    onNext,
    navigateToParent,
    alternativer,
    kategoriId,
    radioButtonsLabel = 'Hva har skjedd?',
    radioButtonsSubLabel = undefined,
}: Props) => {
    const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);
    const windowScollTop = useWindowScrollTop();
    const bankregnr = useBankregnr();
    return (
        <>
            <form className="meld-skade-form">
                <Header svgCardType={svgCardType} title={title} subtitle="Skademelding" />
                <RadioButtons
                    name=""
                    label={radioButtonsLabel}
                    ingress={radioButtonsSubLabel}
                    options={toOptions(alternativer, kategoriId)}
                    selectedOption={selectedOption}
                    onChange={setSelectedOption}
                    focusOnMount
                />
                <StepNavigation
                    bankregnr={bankregnr}
                    next={{
                        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            e.preventDefault();
                            onNext(selectedOption);
                        },
                        disabled: !selectedOption,
                    }}
                    prev={{
                        onClick: () => {
                            windowScollTop();
                            navigateToParent();
                        },
                    }}
                    sideDetail={{ type: SideType.Kategoriside, kategoriId }}
                />
            </form>
            <SporreskjemaButton />
        </>
    );
};
